import type { Diagnosis } from '@/types'

export const DIAGNOSIS_FINEPRINT = "Ranges reflect typical Riverton-area jobs in 2026. Your technician confirms the exact figure with you before any work begins."

export const diagnoses: Diagnosis[] = [
    {
        id: 'spring',
        title: "Broken spring",
        description: "A loud bang, a door that won't lift, a gap in the coil",
        fix: "Fit both torsion springs as a matched pair, check the cables and rebalance the door.",
        urgency: "Same day. Leave the door closed.",
        level: 'high',
        lo: 225,
        hi: 395,
        safety: "With the spring gone, nothing is holding the door's full weight, often 150+ lb. Don't lift it by hand and don't let the opener try.",
        formService: 'spring'
    },
    {
        id: 'stuck',
        title: "Won't open or close",
        description: "The opener hums, or the door reverses or sits still",
        fix: "Most often it's misaligned safety sensors, a spring or the opener's force setting. We check all three.",
        urgency: "Within 24 hours",
        level: 'medium',
        lo: 95,
        hi: 395,
        formService: 'diagnosis-visit'
    },
    {
        id: 'track',
        title: "Off track or crooked",
        description: "One side hangs low, rollers have left the rail",
        fix: "Seat the rollers, straighten or replace the bent track and swap any frayed cables.",
        urgency: "Same day. A loose door can fall.",
        level: 'high',
        lo: 175,
        hi: 350,
        safety: "Keep cars and people away from a crooked door and unplug the opener so it stops pulling.",
        formService: 'offtrack',
        answers: { urgency: "Today" }
    },
    {
        id: 'noisy',
        title: "Noisy or jerky",
        description: "Grinding, squealing or shaking on the way up",
        fix: "A tune-up: nylon rollers, tightened hinges, lubrication and a balance test.",
        urgency: "This week",
        level: 'low',
        lo: 95,
        hi: 285,
        formService: 'tune-up'
    },
    {
        id: 'opener',
        title: "Opener trouble",
        description: "Dead remote or keypad, or the motor runs and nothing moves",
        fix: "Repair the gear, logic board or remotes, or move up to a quiet belt-drive smart opener.",
        urgency: "Within 24–48 hours",
        level: 'medium',
        lo: 125,
        hi: 900,
        formService: 'opener'
    },
    {
        id: 'panel',
        title: "Damaged panel",
        description: "A dent, a crack or a section bent by a car",
        fix: "Replace the damaged section or sections, matched to your door's model and color.",
        urgency: "This week (sooner if it won't seal)",
        level: 'low',
        lo: 250,
        hi: 800,
        formService: 'panel'
    },
    {
        id: 'new',
        title: "Ready for a new door",
        description: "A fresh look, better insulation, or both",
        fix: "A free in-home measure, three style options, and an install that takes a single day.",
        urgency: "Plan ahead: 1–3 weeks lead time",
        level: 'low',
        lo: 1150,
        hi: 4800,
        formService: 'new-door'
    }
]

export const getDiagnosisById = (id: string): Diagnosis | undefined =>
    diagnoses.find(diagnosis => diagnosis.id === id)
